import { linksConstants } from "../../src/constants/linksConstants";
import { meta } from "../../src/landingPage/datasets/meta";
import { NextHead } from "../../src/landingPage/layouts/LayoutComponents/NextHead";
// import butter from "@/src/landingPage/utils/butter-client";
import { PoweringCaseStudies } from "../../src/landingPage/views/Powering/PoweringCaseStudies";
import { InfoBox } from "../../src/landingPage/views/components/form/InfoBox";
import { useEffect, useState } from "react";
import caseStudyData from "./static/data.json";

const PoweringLandingPage = ({ data }) => {
  const [attentionBox, setAttentionBox] = useState(false);

  useEffect(() => {
    if (window.location.state) {
      const isInfoboxPresent = window.location.state.infobox;
      if (isInfoboxPresent) setAttentionBox(true);
    }
  }, []);
  return (
    <>
      {attentionBox && <InfoBox closeModal={() => setAttentionBox(false)} type="Attention" />}
      <NextHead
        currentPath={linksConstants.POWERING.path}
        title={meta.case_study.title}
        description={meta.case_study.description}
      />
      <PoweringCaseStudies data={data} />
    </>
  );
};

export const getServerSideProps = async () => {
  try {
    //    const response = await butter.page.retrieve("*", "powering-case-studies");
    //    const data = response.data.fields;
    //    console.log(data);
    const data = caseStudyData;
    data.poweringcasestudies = data.poweringcasestudies.filter(caseStudy => caseStudy.id >= 0);
    return {
      props: {
        data,
        wrapper: "MarketingWrapper",
      },
    };
  } catch (e) {
    console.error(e);
    return {
      notFound: true,
    };
  }
};

export default PoweringLandingPage;
